import React, { Component } from 'react';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import API from '../../services/API';
import Form from './components/Form';
import Table from './components/Table';
import SyncMessage from "../../components/SyncMessage";

class SSRotator extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            report: [],
            syncData: null
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSync = this.handleSync.bind(this);
    }

    componentDidMount() {
        API.SSRotator.get().then(({ report }) => this.setState({ report }))
    }

    handleSubmit({ zone, ssId }) {
        this.setState({ isLoading: true });

        API.SSRotator.save(zone, ssId).then(() => {
            API.SSRotator.get().then(({ report }) => this.setState({ report, isLoading: false }))
        });
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.Sync(['app'], 'ssRotator', 8081)
            .then((res) => {
                this.setState({ isLoading: false, syncData: { res } });
            })
            .catch(err => {
                this.setState({ isLoading: false, syncData: { reqErr: err } });
            });
    }

    getTable() {
        const { report } = this.state;

        if(!report.length) return <p>No data</p>;

        return <Table report={report}/>
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="SS Rotator"/>
                <Form onSubmit={this.handleSubmit} onSync={this.handleSync}/>
                <SyncMessage {...this.state.syncData} />

                {this.getTable()}
            </Container>
        );
    }
}

export default SSRotator;


// WEBPACK FOOTER //
// ./src/scenes/SSRotator/index.js